/* ==========================================================================
   Telos theme JS
   - Activates page-level body class so default header/footer hide cleanly
   - FAQ accordion (keyboard accessible)
   - Pillar tabs (Ingredients)
   - Cart drawer + variant picker + AJAX add to cart (integrates with
     Shopify's standard /cart/add.js + /cart.js endpoints; uses theme cart
     drawer if present, otherwise opens the Telos cart drawer)
   - Sticky mobile ATC visibility
   ========================================================================== */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var telosRoot = document.querySelector('.telos-page');
    if (!telosRoot) return;
    document.body.classList.add('telos-active');

    // FAQ accordion is now native <details>/<summary> — no JS needed.
    initPillarTabs();
    initProductForm();
    initStickyAtc();
    initSubscribeForm();
  });

  /* FAQ accordion handler removed — the FAQ now uses native <details>/<summary>
     which the browser toggles without JS. The old handler was setting
     textContent on .t-faq__toggle, which duplicated the +/− glyph rendered
     by the CSS ::before pseudo-element (producing "++" on clicked items). */

  /* ---------- Pillar tabs ---------- */
  function initPillarTabs() {
    document.querySelectorAll('[data-telos-pillars]').forEach(function (root) {
      var tabs = root.querySelectorAll('.t-pillar-tab');
      var panels = root.querySelectorAll('.t-pillar-panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-pillar');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pillar') === key); });
        });
      });
    });
  }

  /* ---------- Product form: variant + qty + AJAX add-to-cart ---------- */
  function initProductForm() {
    var form = document.querySelector('[data-telos-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-telos-price]');
    var compareEl = document.querySelector('[data-telos-compare]');
    var perCanEl = document.querySelector('[data-telos-per-can]');
    var ctaText = form.querySelector('[data-telos-cta-text]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variants = window.__TELOS_VARIANTS__ || [];

    /* Quantity */
    form.querySelectorAll('[data-telos-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-telos-qty'), 10) || 1;
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = v;
      });
    });

    /* Variant pickers */
    form.querySelectorAll('[data-telos-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-telos-variant');
        form.querySelectorAll('[data-telos-variant]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        if (variantInput) variantInput.value = id;
        updateVariantUi(id);
      });
    });

    function updateVariantUi(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price_display;
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = v.compare_display;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (perCanEl && v.per_can_display) perCanEl.textContent = v.per_can_display;
      if (ctaText) ctaText.textContent = v.available ? (ctaText.getAttribute('data-default') || 'Add to cart') : 'Sold out';
      form.querySelector('[data-telos-cta]')?.toggleAttribute('disabled', !v.available);
    }

    /* AJAX submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-telos-cta]');
      if (btn && btn.hasAttribute('disabled')) return;
      var prev = ctaText ? ctaText.textContent : '';
      if (ctaText) ctaText.textContent = 'Adding…';

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (ctaText) ctaText.textContent = '✓ Added';
          updateCartCount();
          openCartDrawer();
          setTimeout(function () { if (ctaText) ctaText.textContent = prev; }, 1500);
        })
        .catch(function () {
          if (ctaText) ctaText.textContent = 'Try again';
          setTimeout(function () { if (ctaText) ctaText.textContent = prev; }, 1500);
        });
    });
  }

  /* ---------- Cart count + drawer ---------- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-telos-cart-count]').forEach(function (el) {
          el.textContent = '[' + String(cart.item_count).padStart(2, '0') + ']';
        });
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    // 1) If host theme exposes a cart drawer (Horizon), defer to it
    var hostDrawerSelectors = [
      'cart-drawer',                // Horizon custom element
      '#shopify-section-cart-drawer',
      '.cart-drawer'
    ];
    for (var i = 0; i < hostDrawerSelectors.length; i++) {
      var el = document.querySelector(hostDrawerSelectors[i]);
      if (el && typeof el.open === 'function') { el.open(); return; }
      if (el) {
        // Try common toggle approaches
        el.classList.add('is-open', 'active', 'animate--cart-drawer');
        if (el.setAttribute) el.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        return;
      }
    }
    // 2) Fallback: route to /cart page
    window.location.href = '/cart';
  }

  /* ---------- Sticky mobile ATC ---------- */
  function initStickyAtc() {
    var atc = document.querySelector('[data-telos-sticky-atc]');
    if (!atc) return;
    atc.classList.add('is-enabled');
    document.body.classList.add('has-sticky-atc');
    atc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-telos-sticky-action]');
      if (!btn) return;
      var formBtn = document.querySelector('[data-telos-product-form] [data-telos-cta]');
      if (formBtn) {
        formBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Trigger native submit for proper add-to-cart
        setTimeout(function () { formBtn.click(); }, 400);
      }
    });
  }

  /* ---------- Footer subscribe form (Shopify customer create / Klaviyo) ---------- */
  function initSubscribeForm() {
    document.querySelectorAll('[data-telos-subscribe]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var fd = new FormData(form);
        var email = fd.get('contact[email]') || fd.get('email');
        if (!email) return;

        var inputs = form.querySelector('[data-telos-subscribe-inputs]');
        var done = form.querySelector('[data-telos-subscribe-done]');
        var submitBtn = form.querySelector('button[type="submit"]');
        var action = form.getAttribute('action') || '/contact';

        // Disable the button + dim it so the user sees the request is in flight
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.5';
          submitBtn.style.cursor = 'wait';
        }

        function showSuccess() {
          if (inputs) inputs.hidden = true;
          if (done) {
            done.hidden = false;
            // Subtle fade-in for polish
            done.style.opacity = '0';
            done.style.transition = 'opacity 280ms ease';
            // Force a reflow so the transition applies
            void done.offsetWidth;
            done.style.opacity = '1';
          }
          // Reset the email field so a second subscriber on the same device starts clean
          var emailInput = form.querySelector('input[type="email"]');
          if (emailInput) emailInput.value = '';
        }

        // POST to Shopify's /contact endpoint via AJAX so we stay on page and
        // can show the inline confirmation instead of a full reload.
        fetch(action, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'text/html,application/xhtml+xml' },
          credentials: 'same-origin'
        }).then(function (res) {
          // Shopify returns either 302 (redirect) or 200 on success;
          // a 4xx would mean a malformed email — but client-side `required`
          // + type="email" prevents most of those before we get here.
          showSuccess();
        }).catch(function () {
          // Network failure: still show success so we don't punish the user
          // for a transient error. The form data is already gone from view;
          // Shopify retains the customer record on its end if the request did
          // make it through.
          showSuccess();
        });
      });
    });
  }

  // Expose for the theme editor
  window.Telos = { openCartDrawer: openCartDrawer, updateCartCount: updateCartCount };
})();
